import MuiButton from './MuiButton';
import MuiInputBase from './MuiInputBase';

export const components = {
  MuiButton,
  MuiInputBase,
};
